import { AgentType } from "@superblocksteam/shared";
import type { Organization } from "@superblocksteam/shared";

export const orgIsOnPremise = (organization: undefined | Organization) =>
  organization?.agentType === AgentType.ONPREMISE;

export const orgIsCloud = (organization: undefined | Organization) =>
  organization?.agentType === AgentType.MULTITENANT;
